import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Button } from '@material-ui/core';
import Input from './components/Input';
import clickHemofiliaLogo from '~/assets/clickhemofilia-logo-registered.png';
import fbhLogo from '~/assets/fbh-logo.png';

import { signInRequest } from '~/store/modules/auth/actions';

import { Container, Left, Right, Title } from './styles';

export default function SignIn() {
  const dispatch = useDispatch();
  const signed = useSelector((state) => state.auth.signed);
  const history = useHistory();
  const formRef = useRef(null);

  useEffect(() => {
    document.title = 'Login | ClickHemofilia';
  }, []);

  useEffect(() => {
    if (signed) {
      history.push('/search');
    }
  }, [signed, history]);

  async function handleSubmit(data, { reset }) {
    try {
      const schema = Yup.object({
        register: Yup.string().required('Campo obrigatório.'),
        password: Yup.string().required('Campo obrigatório.'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });
      // Validation passed

      const { register, password } = data;
      dispatch(signInRequest(register, password));
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  return (
    <Container>
      <Left>
        <img id="clickhemofilia-logo" src={clickHemofiliaLogo} alt="clickhemofilia-logo" />
      </Left>

      <Right>
        <img id="fbh-logo" src={fbhLogo} alt="fbh-logo" />

        <Title>Bem vindo(a) ao ClickHemofilia</Title>

        <Form onSubmit={handleSubmit} ref={formRef}>
          <Input
            placeholder="Digite seu número de registro"
            name="register"
            fullWidth
            required
          />

          <Input
            placeholder="Sua senha secreta"
            name="password"
            type="password"
            fullWidth
            autoComplete="current-password"
            required
          />

          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
          >
            Entrar
          </Button>
        </Form>
      </Right>
    </Container>
  );
}
